import posthog from 'posthog-js';

// Get the user's timezone using Intl API
export const inferredTimeZone =
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export const triggerAnalyticsEvent = (event: AnalyticsEventData): void => {
  posthog.capture(event.eventName, { ...event.data, inferredTimeZone });
};

export type AnalyticsEventData =
  | NavigationAnalyticsEvent
  | FormSubmitAnalyticsEvent
  | FormSubmitResultAnalyticsEvent
  | ModalOpenAnalyticsEvent;

export interface NavigationAnalyticsEvent {
  eventName: 'navigation';
  data: {
    type: 'tab_change' | 'list_item_selection' | 'anchor_link' | 'main_menu';
    previous_location: string | null;
    new_location: string;
    element:
      | 'tab'
      | 'vertical_tab'
      | 'list_item'
      | 'anchor_link'
      | 'button'
      | 'other';
    trigged_by: 'mouse_click' | 'key_press' | 'system';
  };
}

export interface FormSubmitAnalyticsEvent {
  eventName: 'form_submit';
  data: {
    form_name: string;
    trigged_by: 'mouse_click' | 'key_press';
  };
}

export interface FormSubmitResultAnalyticsEvent {
  eventName: 'form_submit_result';
  data: {
    type: 'error' | 'success';
    form_name: string;
    error_reason: string | null;
  };
}

export interface ModalOpenAnalyticsEvent {
  eventName: 'dialog';
  data: {
    type: 'side_panel' | 'modal';
    action: 'open' | 'close';
    dialog_name: string;
    element: 'anchor_link' | 'button' | 'other';
    trigged_by: 'mouse_click' | 'key_press' | 'system';
  };
}

// NOT IMPLEMENTED YET
// following events are not implemented yet, but they are defined here for future reference

export interface TableOperationAnalyticsEvent {
  eventName: 'table_operation';
  data: {
    type: 'sort' | 'filter';
    previous_value: Map<string, string> | null;
    new_value: Map<string, string>; // e.g. { "hostname": "asc" }
    trigged_by: 'mouse_click' | 'key_press' | 'system';
  };
}

export interface IntentCheckOperationAnalyticsEvent {
  eventName: 'intent_check_operation';
  data: {
    type: 'create' | 'edit' | 'remove';
    intent_name: string;
    previous_value: null;
    new_value: {
      target_column: string;
      // e.g. [{"column": "hostname", "operator": "equal", "value": "hw"}],
      success: Map<string, string>[] | null;
      info: Map<string, string>[] | null;
      warning: Map<string, string>[] | null;
      error: Map<string, string>[] | null;
    };
    trigged_by: 'mouse_click' | 'key_press' | 'system';
  };
}

export interface DiagramOperationAnalyticsEvent {
  eventName: 'diagram_operation';
  data: {
    type: 'open' | 'save' | 'export';
    diagram_name: string;
  };
}

export interface DiagramObjectOperationAnalyticsEvent {
  eventName: 'diagram_object_operation';
  data: {
    type: 'move' | 'hide' | 'align' | 'expand' | 'collapse' | 'layout_change';
    diagram_name: string;
    target: string[];
  };
}
